(function(){
  var h=document.querySelector('[data-lfh]'); if(!h||h.__lfh) return; h.__lfh=1;
  var cur=null,t=null,want=null,mq=window.matchMedia('(min-width: 990px)');

  /* Oct 28 2026 (speed): department mega-menu panels and the phone drill-down are not in the page HTML
     (data-lfh-lazyload). They are fetched once from /?view=lfmenu&sections=<header> (templates/index.lfmenu.liquid),
     cached for the session, and dropped into the empty panels. Started on idle after load, or earlier on the first
     hover / focus of the menu bar or a tap on the menu button. */
  var lp=null, lazy=h.hasAttribute('data-lfh-lazyload');
  function sid(){ var s=h.closest('.shopify-section'); return s?s.id.replace('shopify-section-',''):''; }
  function apply(html){
    if(!html) return;
    var d=new DOMParser().parseFromString(html,'text/html');
    h.querySelectorAll('[data-lfh-mm][data-lfh-lazy]').forEach(function(p){
      var n=d.getElementById(p.id); if(!n) return;
      p.innerHTML=n.innerHTML; p.removeAttribute('data-lfh-lazy');
    });
    var tp=d.getElementById('lfhPanelsT'), pn=h.querySelector('.lfh__panels');
    if(tp&&pn&&!h.querySelector('#lfhPanelsT')&&!pn.querySelector('[data-lfh-panel]:not([data-lfh-panel="root"])')){
      var t2=document.createElement('template'); t2.id='lfhPanelsT'; t2.innerHTML=tp.innerHTML; pn.appendChild(t2);
    }
    lazy=false;
  }
  function load(){
    if(!lazy) return Promise.resolve();
    if(lp) return lp;
    var S=window.Shopify||{}, th=S.theme||{}, id=sid();
    if(!id) return Promise.resolve();
    var key='lfhMenu:'+(th.id||'')+':'+id, c=null;
    try{ c=sessionStorage.getItem(key); }catch(e){}
    if(c){ apply(c); return lp=Promise.resolve(); }
    var root=(S.routes&&S.routes.root)||'/';
    var url=root+'?view=lfmenu&sections='+encodeURIComponent(id)+(th.role&&th.role!=='main'&&th.id?'&preview_theme_id='+th.id:'');
    lp=fetch(url,{credentials:'same-origin'}).then(function(r){ if(!r.ok) throw 0; return r.json(); }).then(function(j){
      var x=j&&j[id]; if(!x) throw 0;
      apply(x); try{ sessionStorage.setItem(key,x); }catch(e){}
    }).catch(function(){ lp=null; });
    return lp;
  }

  function trig(id){return h.querySelector('[data-lfh-dd="'+id+'"]')}
  function show(id,then){
    if(cur===id) return; 
    var p=h.querySelector('[data-lfh-mm="'+id+'"]'); if(!p) return;
    if(p.hasAttribute('data-lfh-lazy')){ want=id; load().then(function(){ if(want===id && !p.hasAttribute('data-lfh-lazy')){ want=null; show(id,then); } }); return; }
    hide(); p.hidden=false; cur=id; var b=trig(id); if(b) b.setAttribute('aria-expanded','true');
    if(then) then(p);
  }
  function hide(){
    want=null;
    if(cur===null) return;
    var p=h.querySelector('[data-lfh-mm="'+cur+'"]'); if(p) p.hidden=true;
    var b=trig(cur); if(b) b.setAttribute('aria-expanded','false'); cur=null;
  }
  function later(fn,ms){clearTimeout(t);t=setTimeout(fn,ms)}
  h.querySelectorAll('[data-lfh-dd]').forEach(function(b){
    var id=b.getAttribute('data-lfh-dd');
    b.addEventListener('mouseenter',function(){ if(mq.matches){ load(); later(function(){show(id)}, cur===null?300:120); } });
    b.addEventListener('click',function(e){
      if(b.tagName==='BUTTON'){ e.preventDefault(); cur===id?hide():show(id); return; }
      /* touch / no-hover: first tap opens, second follows the link (Baymard #291) */
      if(!window.matchMedia('(hover: hover)').matches && cur!==id){ e.preventDefault(); show(id); }
    });
    b.addEventListener('keydown',function(e){
      if((e.key==='ArrowDown'||e.key===' ')&&b.tagName!=='BUTTON'){ e.preventDefault(); show(id,function(p){ var f=p.querySelector('a'); if(f) f.focus(); }); }
    });
  });
  h.querySelectorAll('[data-lfh-plain]').forEach(function(a){ a.addEventListener('mouseenter',function(){ later(hide,400); }); });
  h.querySelectorAll('[data-lfh-mm]').forEach(function(p){ p.addEventListener('mouseenter',function(){clearTimeout(t)}); });
  var bar=h.querySelector('.lfh__navbar');
  bar.addEventListener('mouseleave',function(){ later(hide,400); });
  bar.addEventListener('mouseenter',function(){ load(); if(cur!==null) clearTimeout(t); });
  bar.addEventListener('focusin',function(){ load(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ if(cur!==null){ var b=trig(cur); hide(); if(b) b.focus(); } closeDrawer(); } });
  document.addEventListener('click',function(e){ if(cur!==null && !bar.contains(e.target)) hide(); });
  bar.addEventListener('focusout',function(e){ if(cur!==null && !bar.contains(e.relatedTarget)) hide(); });

  /* mobile drawer. The department drill-down panels arrive inside <template id="lfhPanelsT"> (fetched, see above) and are added to the page the first time the drawer opens (or on idle). */
  var dr=h.querySelector('#lfhDrawer'), sc=h.querySelector('.lfh__scrim'), ob=h.querySelector('[data-lfh-open]'), pn=h.querySelector('.lfh__panels');
  function fill(){ var tp=h.querySelector('#lfhPanelsT'); if(!tp||!pn) return; var c=tp.content; tp.parentNode.removeChild(tp); pn.appendChild(c); }
  function openDrawer(){ fill(); load().then(fill); dr.hidden=false; sc.hidden=false; ob.setAttribute('aria-expanded','true'); document.documentElement.style.overflow='hidden'; var f=dr.querySelector('.lfh__x'); if(f) f.focus(); }
  function closeDrawer(){ if(!dr||dr.hidden) return; dr.hidden=true; sc.hidden=true; ob.setAttribute('aria-expanded','false'); document.documentElement.style.overflow=''; ob.focus(); }
  /* Keep keyboard navigation inside the open modal menu, including lazy-loaded panels. */
  if(dr) dr.addEventListener('keydown',function(e){
    if(e.key!=='Tab'||dr.hidden) return;
    var items=Array.prototype.filter.call(dr.querySelectorAll('a[href],button,input,select,textarea,[tabindex]'),function(n){
      return !n.matches(':disabled') && n.getAttribute('aria-disabled')!=='true' && n.tabIndex>=0 && !n.closest('[hidden],[inert]') && n.getClientRects().length && getComputedStyle(n).visibility!=='hidden';
    });
    if(!items.length){ e.preventDefault(); var close=dr.querySelector('.lfh__x'); if(close) close.focus(); return; }
    var first=items[0], last=items[items.length-1], active=document.activeElement;
    if(e.shiftKey && (active===first || !dr.contains(active))){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && (active===last || !dr.contains(active))){ e.preventDefault(); first.focus(); }
  });
  if(ob){ ob.addEventListener('click',openDrawer); ob.addEventListener('touchstart',function(){ load(); },{passive:true}); }
  h.querySelectorAll('[data-lfh-close]').forEach(function(x){ x.addEventListener('click',closeDrawer); });
  function go(to){
    var p=pn.querySelector('[data-lfh-panel="'+to+'"]');
    if(!p){ load().then(function(){ fill(); if(pn.querySelector('[data-lfh-panel="'+to+'"]')) go(to); }); return; }
    pn.querySelectorAll('[data-lfh-panel]').forEach(function(q){ q.hidden = q.getAttribute('data-lfh-panel')!==to; });
    var f=p.querySelector('button,a'); if(f) f.focus();
    pn.scrollTop=0;
  }
  if(pn) pn.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-lfh-go]'); if(!b||!pn.contains(b)) return;
    go(b.getAttribute('data-lfh-go'));
  });
  function idle(){ (window.requestIdleCallback||function(f){setTimeout(f,1500)})(function(){ load().then(function(){ if(!mq.matches) fill(); }); },{timeout:4000}); }
  if(document.readyState==='complete') idle(); else window.addEventListener('load',idle);

  window.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-lfh-cart]');
    if (!a || !h.contains(a) || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var s = window.Rebuy && window.Rebuy.SmartCart;
    if (window.lfCartAB !== 'smart_cart' || !s || typeof s.show !== 'function') { window.location.assign(a.href); return; }
    try { s.show(); } catch (_) { window.location.assign(a.href); return; }
    setTimeout(function () {
      var cart = document.getElementById('rebuy-cart');
      var visible = cart && cart.getClientRects().length && getComputedStyle(cart).visibility !== 'hidden' &&
        (document.documentElement.classList.contains('rebuy-cart-visible') || document.body.classList.contains('rebuy-cart-visible') || cart.getAttribute('aria-hidden') === 'false');
      if (!visible) window.location.assign(a.href);
    }, 1500);
  }, true);

  /* live cart count + subtotal */
  function money(c){ try{ return (window.Shopify&&Shopify.formatMoney)?Shopify.formatMoney(c):'$'+(c/100).toFixed(2); }catch(e){ return '$'+(c/100).toFixed(2); } }
  function displayCount(cart) {
    return (cart.items || []).reduce(function (n, item) {
      var rolls = Number(item.properties && item.properties['Roll(s)']);
      return n + (Number.isFinite(rolls) && rolls > 0 ? rolls : Number(item.quantity) || 0);
    }, 0);
  }
  function paint(cart){ if(!cart) return; var count=displayCount(cart), n=h.querySelector('[data-lfh-count]'), tt=h.querySelector('[data-lfh-total]'), a=h.querySelector('[data-lfh-cart]');
    if(n) n.textContent=count; if(tt) tt.textContent=money(cart.total_price);
    if(a) a.setAttribute('aria-label','Cart, '+count+(count===1?' item, ':' items, ')+money(cart.total_price)); }
  var cartSeq = 0;
  function refresh(){ var seq = ++cartSeq; fetch('/cart.js',{credentials:'same-origin',cache:'no-store'}).then(function(r){if(!r.ok) throw new Error('Cart unavailable'); return r.json()}).then(function(cart){if(seq === cartSeq) paint(cart);}).catch(function(){}); }
  document.addEventListener('cart:updated',refresh);
  document.addEventListener('lf:cart-updated',refresh);
  window.addEventListener('pageshow',function(e){ if(e.persisted) refresh(); });
})();

